import { KebabMenu } from '@modules/common/components/KebabMenu';
import { MenuItemOptions } from '@modules/common/components/KebabMenu/types';
import { LinkOffRounded } from '@mui/icons-material';
import { Typography } from '@mui/material';

interface MetadataFieldMappingActionsMenuProps {
  onRemoveLink: () => void;
  isDisabled?: boolean;
}

export const MetadataFieldMappingActionsMenu = ({
  onRemoveLink,
  isDisabled,
}: MetadataFieldMappingActionsMenuProps) => {
  const kebabMenuItems: MenuItemOptions = [
    {
      icon: (
        <LinkOffRounded
          fontSize="small"
          sx={{
            color: 'error.light',
          }}
        />
      ),
      label: <Typography color="error.light">Remove link</Typography>,
      onClick: onRemoveLink,
    },
  ];

  return (
    <KebabMenu
      menuItems={kebabMenuItems}
      buttonProps={{
        color: 'primary',
        size: 'small',
        disabled: isDisabled,
      }}
      menuProps={{
        PaperProps: {
          sx: {
            minWidth: '150px',
          },
        },
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'center',
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'right',
        },
      }}
    />
  );
};
